export default {
  tabs: {
    api: "API",
    assistant: "Assistant",
    agentic: "Agentic",
    gateway: "Gateway",
    engine: "Engine"
  },
  modes: {
    logs: "Logs",
    chats: "Chats",
    tools: "Tools",
    agents: "Workflows",
    history: "History"
  },
  agents: {
    searchPlaceholder: "Search workflow executions...",
    terminalTitle: "Workflow executions (Engine)",
    liveFeed: "Live feed",
    itemCount: "{{count}} executions",
    empty: "No executions in the selected period.",
    loadError: "Could not load the workflow-execution feed.",
    refresh: "Refresh",
    sessions: "Workflows",
    allSessions: "All workflows",
    noSessions: "No executions in this period.",
    executions: "executions",
    openSession: "Open workflow",
    duration: "Duration",
    steps: "Steps",
    tokens: "Tokens"
  },
  chats: {
    searchPlaceholder: "Search conversations...",
    terminalTitle: "Anonymized conversations (Agentic)",
    liveFeed: "Live feed",
    itemCount: "{{count}} conversations",
    empty: "No conversations in the selected period.",
    noResponse: "No response recorded",
    loadError: "Could not load the conversation feed.",
    refresh: "Refresh",
    sessions: "Sessions",
    allSessions: "All sessions",
    noSessions: "No sessions in this period.",
    messages: "msgs",
    filterSession: "Filter by this session",
    expand: "Expand",
    collapse: "Collapse",
    openSession: "Open conversation"
  },
  tools: {
    searchPlaceholder: "Search tool calls...",
    terminalTitle: "MCP tool calls (Gateway)",
    liveFeed: "Live feed",
    itemCount: "{{count}} calls",
    empty: "No tool calls in the selected period.",
    params: "Parameters",
    loadError: "Could not load the tool-call feed.",
    refresh: "Refresh",
    sessions: "Sessions",
    allSessions: "All sessions",
    noSessions: "No sessions in this period.",
    calls: "calls",
    failed: "failed",
    lastTool: "Last tool",
    filterSession: "Filter by this session",
    toggleResult: "View result",
    resultPreview: "Result (excerpt)",
    openSession: "Open session"
  },
  agenticTerminalTitle: "Agentic Log Terminal",
  gatewayTerminalTitle: "Gateway Log Terminal",
  engineTerminalTitle: "Engine Log Terminal",
  searchPlaceholder: "Search logs...",
  level: "Level",
  allLevels: "All levels",
  connectionError: "Connection error",
  waitingForLogs: "Waiting for logs...",
  paused: "Paused",
  liveUpdatesFailing: "Live updates failing — data may be stale",
  pause: "Pause",
  resume: "Resume",
  title: "Logs",
  description: "View system logs in real-time",
  selectFile: "Select log file",
  selectFileToView: "Select a log file to view",
  noFilesFound: "No log files found",
  noLogEntries: "No log entries to display",
  refreshFileList: "Refresh file list",
  startStreaming: "Start real-time monitoring",
  stopStreaming: "Stop real-time monitoring",
  start: "Start",
  stop: "Stop",
  clearLogs: "Clear logs",
  lineCount: "{{count}} lines",
  streamingActive: "Real-time monitoring active",
  streamingStopped: "Real-time monitoring inactive",
  liveStreaming: "Receiving logs in real-time",
  monitoringStopped: "Log monitoring stopped",
  terminalTitle: "System Log Terminal",
  fullscreenTitle: "Fullscreen Terminal",
  copied: "Logs copied",
  copiedDescription: "Logs have been copied to clipboard",
  copyError: "Copy error",
  copyErrorDescription: "Failed to copy logs to clipboard",
  copyLogsTitle: "Copy Logs",
  reconnecting: "Reconnecting...",
  dateSelector: "Date",
  liveOption: "Live (today)",
  historicalSnapshot: "Historical snapshot — no live updates",
  loadingHistorical: "Loading historical logs...",
  historicalUnavailable: "Historical file unavailable — it may have been rotated out.",
  failedToListFiles: "Could not load the list of available dates."
} as const;
